module.exports = __webpack_public_path__ + "img/bacon.90f9d5a2.svg";